import { addPopup } from "commons/popup/AbsPopupType";
import { lazy } from "react";
import { type IButton } from "../../commons/popup/store/absPopupVo";

export enum PopupType {
  SERVICE_GUIDE_POPUP = "service_guide_popup",

  CHECK_POPUP = "check_popup",
  IMAGE_VIEW = "image_view",
  IERROR_POPUP = "error_popup",
  NOTICE_POPUP = "notice_popup",
  PAYMENT_POPUP = "payment_popup",
  NOTICE_LIST_POPUP = "notice_list_popup",
  PASSWD_RESET_POPUP = "passwd_reset_popup",
  ALARM_TALK_POPUP = "alarm_talk_popup",
  CALCULATE_RATIO_POPUP = "calculate_ratio_popup",
  CSV_UPLOAD_POPUP = "csv_upload_popup",
  BRAND_CSV_UPLOAD_POPUP = "brand_csv_upload_popup",
  BRAND_CSV_DOWNLOAD_POPUP = "brand_csv_download_popup",
  USER_MANAGE_POPUP = "user_manage_popup",
  USER_INFO_POPUP = "user_info_popup",
  MusicUpload = "music_upload",
  CONSALAD_USER_MAPPING = "consalad_user_mapping",
  CONSALAD_USER_DETAIL = "consalad_user_detail",
  ICON = "Icon",

  CHANNEL_REGISTER_POPUP = "channel_register_popup",
  RSS_REGISTER_POPUP = "rss_register_popup",

  TRANSLATE_WORKER_POPUP = "translate_worker_popup",
  TRANSLATE_DISTRIBUTE_POPUP = "translate_distribute_popup",
  TRANSLATE_TITLE_SELECT_POPUP = "translate_title_select_popup",

  CAL_COMPANY_DETAIL_POPUP = "cal_company_detail_popup",

  // uiux개편 이후 업데이트 소식 팝업
  UIUX_UPDATE_POPUP = "uiux_update_popup",
}
export interface IImageViewPopupData {
  title?: string;
  image?: string;
  buttons?: IButton[];
}
export interface IErrorPopUp {
  msgErr?: string;
  buttons?: IButton[];
}

const ServiceGuidePopup = lazy(() => import("./display/ServiceGuidePopup"));

const ImageView = lazy(() => import("./display/ImagePreview"));
const ErrorPopup = lazy(() => import("./display/ErrorPopup"));
const ICon = lazy(() => import("./display/IconPopup"));

const PAYMENT_POPUP = lazy(() => import("./payment/PaymentPopup"));

const NoticePopup = lazy(() => import("./notice/NoticePopup"));
const NoticeListPopup = lazy(() => import("./noticeList/NoticeListPopup"));

const PasswdResetPopup = lazy(() => import("./passwdReset/passwdResetPopup"));

const CalculateRatioPopup = lazy(() => import("./calculateRatio/calculateRatioPopup"));

const AlarmTalkPopup = lazy(() => import("./alarmtalk/AlarmtalkPopup"));
const CSVUploadPopup = lazy(() => import("./insight/CSVUploadPopup"));

const UserManagePopup = lazy(() => import("./userinfo/UserManagePopup"));
const UserInfoPopup = lazy(() => import("./userinfo/UserInfoPopup"));
const BrandCSVUpload = lazy(() => import("./brandCSV/UploadBrandCSV"));
const MusicUpload = lazy(() => import("./insight/consalad/MusicUpload"));
const ConsaladUserMapping = lazy(() => import("./user/mapping/consaladMapping"));
const ConsaladUserDetail = lazy(() => import("./user/mapping/consaladMappingDetail"));

const ChannelRegisterPopup = lazy(() => import("./channel/ChannelRegisterPopup"));
const RssRegisterPopup = lazy(() => import("./rss/RssRegisterPopup"));

const TranslateWorkerPopup = lazy(() => import("./translation/worker/WorkerPopup"));
const TranslateDistributePopup = lazy(() => import("./translation/distribute/DistributePopup"));
const TranslateTitleSelectPopup = lazy(() => import("./translation/title/TItleSelectPopup"));

const CalCompanyDataDownPopup = lazy(() => import("./calculate/company/DataDownPopup"));

const UiuxUpdatePopup = lazy(() => import("./uiux/UpdatePopup"));

addPopup(PopupType.SERVICE_GUIDE_POPUP, ServiceGuidePopup);
addPopup(PopupType.IMAGE_VIEW, ImageView);
addPopup(PopupType.IERROR_POPUP, ErrorPopup);
addPopup(PopupType.NOTICE_POPUP, NoticePopup);
addPopup(PopupType.PAYMENT_POPUP, PAYMENT_POPUP);
addPopup(PopupType.NOTICE_LIST_POPUP, NoticeListPopup);
addPopup(PopupType.PASSWD_RESET_POPUP, PasswdResetPopup);
addPopup(PopupType.ALARM_TALK_POPUP, AlarmTalkPopup);
addPopup(PopupType.CALCULATE_RATIO_POPUP, CalculateRatioPopup);
addPopup(PopupType.CSV_UPLOAD_POPUP, CSVUploadPopup);
addPopup(PopupType.USER_INFO_POPUP, UserInfoPopup);
addPopup(PopupType.USER_MANAGE_POPUP, UserManagePopup);
addPopup(PopupType.ICON, ICon);
addPopup(PopupType.BRAND_CSV_UPLOAD_POPUP, BrandCSVUpload);
addPopup(PopupType.MusicUpload, MusicUpload);
addPopup(PopupType.CONSALAD_USER_MAPPING, ConsaladUserMapping);
addPopup(PopupType.CONSALAD_USER_DETAIL, ConsaladUserDetail);
addPopup(PopupType.CHANNEL_REGISTER_POPUP, ChannelRegisterPopup);
addPopup(PopupType.RSS_REGISTER_POPUP, RssRegisterPopup);
addPopup(PopupType.TRANSLATE_WORKER_POPUP, TranslateWorkerPopup);
addPopup(PopupType.TRANSLATE_DISTRIBUTE_POPUP, TranslateDistributePopup);
addPopup(PopupType.TRANSLATE_TITLE_SELECT_POPUP, TranslateTitleSelectPopup);
addPopup(PopupType.CAL_COMPANY_DETAIL_POPUP, CalCompanyDataDownPopup);
addPopup(PopupType.UIUX_UPDATE_POPUP, UiuxUpdatePopup);
// NOTE: 페이지 레이어팝업
// addPopup(PopupType.PRODUCT, ProductPopup);
